export const sum = (numbers: number[]) => {
  return numbers.reduce((total, num) => total + num, 0);
};
